import { FormControl, styled } from "@mui/material";

export const FormControlStyled = styled(FormControl)<{ label?: number }>`
  .MuiOutlinedInput-root {
    background-color: transparent;
    border-radius: 10px;
  }

  .MuiOutlinedInput-notchedOutline {
    border: 1px solid #ABAFB1; /* Default border */
    border-radius: 10px;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid #ABAFB1; /* Prevent red border on focus */
  }

  .MuiSelect-select {
    background-color: transparent; /* inner select box */
    color: #202546; /* optional: text color */
  }

  .MuiSvgIcon-root {
    color: #202546; /* optional: dropdown icon color */
  }

  .MuiInputBase-root {
    background-color: transparent; /* ✅ Fix for Autocomplete */
    color: #202546;
  }

  .MuiAutocomplete-inputRoot {
    background-color: transparent; /* ✅ Also needed for Autocomplete input */
    border-radius: 10px;
  }
  select:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #202546 inset !important;
    box-shadow: 0 0 0 1000px #202546 inset !important;
    transition: background-color 5000s ease-in-out 0s;
      -webkit-text-fill-color: #ABAFB1!important;

    border: none !important; 
    border-radius: 0;
  }
      /* ✅ For single select: selected option background */
  .MuiSelect-select.MuiSelect-select {
    background-color: transparent;
    color: #ABAFB1; /* text color of selected */
  }
      /* ✅ For multiple select: chips or selected values */
  .MuiSelect-multiple .MuiChip-root {
    background-color: #transparent; /* chip bg */
    color: #ABAFB1; /* chip text */
    border-radius: 6px;
    font-size: 0.875rem;
  }
      /* Optional: hover on chip */
  .MuiSelect-multiple .MuiChip-root:hover {
    background-color: #2b2f57;
  }
  /* ✅ Dropdown menu: highlight selected item */
  .MuiMenuItem-root.Mui-selected {
    background-color: #202546 !important; /* selected bg */
    color: #ABAFB1!important; /* selected text */
  }
      .MuiMenuItem-root.Mui-selected:hover {
    background-color: #2b2f57 !important; /* hover on selected */
  }

  .MuiSelect-multiple .MuiChip-root {
  background-color: #202546 !important;  /* ✅ your dark background */
  color: #ABAFB1!important;             /* ✅ light text */
  border-radius: 6px;
  font-weight: 500;
}

.MuiSelect-multiple .MuiChip-root .MuiChip-deleteIcon {
  color: #ABAFB1!important;             /* ✅ close (X) icon color */
}

.MuiSelect-multiple .MuiChip-root:hover {
  background-color: #2b2f57 !important;  /* ✅ slightly lighter hover effect */
}
`;
